const classList = () => import('./classList');
const classDetail = () => import('./classDetail');
const classInfo = () => import('./classInfo');
const approvalList = () => import('./approvalList');
const groupList = () => import('./groupList');
const memberList = () => import('./memberList');
const addClass = () => import('./addClass');

const teach = [
  {
    path: 'classList',
    name: 'classList',
    component: classList,
    meta: {
      title: '班级列表',
    },
  },
  {
    path: 'addClass',
    name: 'addClass',
    component: addClass,
    meta: {
      title: '创建班级',
    },
  },
  {
    path: 'classDetail',
    name: 'classDetail',
    component: classDetail,
    meta: {
      title: '班级详情',
    },
  },
  {
    path: 'classInfo',
    name: 'classInfo',
    component: classInfo,
    meta: {
      title: '班级管理',
    },
  },
  {
    path: 'approvalList',
    name: 'approvalList',
    component: approvalList,
    meta: {
      title: '班级管理',
    },
  },
  {
    path: 'groupList',
    name: 'groupList',
    component: groupList,
    meta: {
      title: '班级管理',
    },
  },
  {
    path: 'memberList',
    name: 'memberList',
    component: memberList,
    meta: {
      title: '班级管理',
    },
  },
];
export default teach;
